import axios from 'axios';   
import router from '../../router/router';


const state = { 
    HallListData: null, // 展位图数据；
    isRegister: false,   // 当前展会是否注册过
    selectBoothComId:'',// 选中的公司id
}
const mutations = {
  setHallListData(state, data) { // 设置展会内容
    console.log(data,'展位图数据')
    // localStorage.setItem("HallListData", JSON.stringify(data));
    state.HallListData = data;
  },
  setRegister(state, bool) { // 设置是否注册
    state.isRegister = bool;
  },
  setSelectBoothComId(state, data) { // 设置选中的公司id
    state.selectBoothComId = data;
  },
}
const getters = {
  getHallListData: state => { // 返回展会信息
    // const data = state.HallListData || JSON.parse(localStorage.getItem('HallListData'));
    const data = state.HallListData
    return  data;
  },
  getRegister: state => { // 返回注册情况
    return state.isRegister;
  },
  getSelectBoothComId: state => { // 返回选中的公司id
    return state.selectBoothComId;
  },
}
const actions = {   
  // 收藏相关
  isCollect({ rootState }, id) { // 获取是否收藏
    return new Promise((resolve, reject) => {
      axios.get("/api/collect/compinfo/iscollect/by?compid=" + id).then(doc => {
        if (doc.data.StatusCode === 200) { resolve(doc.data.Data.IsCollect); }
        else { reject(false); }
      });
    });
  },
  addCollect({ rootState }, id) { // 添加收藏
    return new Promise((resolve, reject) => {
      axios.post("/api/collect/compinfo", { "CompId": id }).then(({ data: { StatusCode, Data } }) => {
        if (StatusCode === 200) { resolve(Data.result); }
        else { reject(false); }
      });
    });
  },
  delCollect({ rootState }, id) { // 删除收藏
    return new Promise((resolve, reject) => {
      axios.post("/api/collect/compinfo/delete", { "CompId": id }).then(({ data: { StatusCode, Data } }) => {
        if (StatusCode === 200) { resolve(Data.result); }
        else { reject(false); }
      });
    });
  },
  getMyCollect({ rootState }, req) { // 获取我的收藏
    return new Promise((resolve, reject) => {
      axios.post("/api/collect/compinfo/getuser/wherepage", req).then(({ data: { StatusCode, Data } }) => {
        if (StatusCode === 200) { resolve(Data.result); }
        else { reject(false); }
      });
    });
  },
  // 贸易对接 
  addTracking({ rootGetters }, req) { // 添加贸易对接  
    return new Promise((resolve, reject) => {
      axios.post("/api/Tracking", req, {headers: {'api-version':2}}).then(({ data: { StatusCode, Data } }) => {
        if (StatusCode === 200) { resolve(Data.result); }
        else { reject(false); }
      });
    });
  }, 
  boothClaim({ rootState }, req) { // 展位认领
    return new Promise((resolve, reject) => {
      axios.post(`/api/BoothClaim`, req, {headers: {'api-version':2}}).then(data => {
        if (data.status === 200) {
          resolve(data.data)
        }
      })
    }).catch(err => {
      console.log(err);
    })
  },
  opinion({ rootState }, req) { // 意见建议
    return new Promise((resolve, reject) => {
      axios.post('/api/JobList', req, {headers: {'api-version':2}}).then(({ data: { StatusCode, Data } }) => {
        if (StatusCode === 200) {
          resolve(Data);
        }
      });
    }).catch(err => { console.log(err); });
  },
  // 判断是否在当前展位是否注册
  getCode({commit, rootGetters },id) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/userinfo/getbarcode/by?itemId=${id}`, rootGetters.getHeader).then(({data: {StatusCode, Data}}) => {
        if (StatusCode === 200 && Data.result) {
          const isRegister = Data.info ? true: false;
          if (isRegister) {
            commit('setRegister', isRegister);
            // commit('setCode', Data.info);
          }
          resolve(Data.info);
        }
      });
    });
  },
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
} 